import React from 'react'

import { Flex, Icon, Text } from 'stardust'
import styled from 'styled-components'

import { FONT_WEIGHTS, LETTER_SPACING, SPACERS } from '~/theme'
import Pill from '~/ui-components/Pill'
import colors from '~/ui-components/tokens/colors'

interface HeaderProps {
  closeAssistModal: () => void
}

const CloseIcon = styled(Icon)`
  border-radius: 50%;
  padding: 10px;
  background-color: ${colors.cosmicShade4};
  &:hover {
    background-color: ${colors.cosmicShade6};
    transition: background-color 0.2s;
  }
`

const Header = ({ closeAssistModal }: HeaderProps) => (
  <Flex alignItems="center">
    <CloseIcon width={40} onClick={closeAssistModal} name="close" data-qa="close_assist_modal" />
    <Text fontSize="20px" fontWeight={600} lineHeight="32px" ml={3} color={colors.cosmicShade10}>
      Assistant
    </Text>
    <Pill
      color="nebulaBlue7"
      text="BETA"
      textColor="cosmicShade0"
      borderRadius={SPACERS.md}
      lineHeight={SPACERS.md}
      letterSpacing={LETTER_SPACING.normal}
      fontWeight={FONT_WEIGHTS.bold}
      ml={SPACERS.md}
      px={SPACERS.sm}
      py={SPACERS.xs}
    />
  </Flex>
)

Header.displayName = 'Header'
export default Header
